module.exports = __webpack_public_path__ + "static/skf-a0d4b249f814c0e5a6f5a41802fc0bd4.jpg";